import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import "../scss/header.scss";

const Header = ({ familyTreeName }) => {
  const navigate = useNavigate();
  const { isAuthenticated, user, logout } = useAuth();
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

  const handleThemeToggle = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);

    const appElement = document.querySelector(".App");
    appElement?.classList.remove(theme);
    appElement?.classList.add(newTheme);
  };

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  const handleHomeClick = () => {
    navigate("/");
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-logo" onClick={handleHomeClick}>
          <span>🌳</span>
          <span className="header-title">
            Coded For Families By{' '}
            <a
              href="https://forkodes.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'inherit', textDecoration: 'underline' }}
            >
              ForKodes
            </a>
          </span>
        </div>
      </div>
      {familyTreeName && (
        <div className="family-tree-name">
          <h1>{familyTreeName}</h1>
        </div>
      )}

      <div className="header-icons">
        <div
          className="theme-toggle"
          onClick={handleThemeToggle}
          title="Toggle theme"
        >
          <span>{theme === "light" ? "🌙" : "☀️"}</span>
        </div>

        {isAuthenticated && user ? (
          <div className="user-menu">
            <span title={`Logged in as ${user.name}`}>👤 {user.name}</span>
            <button onClick={handleLogout} title="Logout">
              🚪
            </button>
          </div>
        ) : null}
      </div>
    </header>
  );
};

export default Header;
